import { Injectable, OnInit } from '@angular/core';
// import { io, Socket } from 'socket.io-client';
import io from 'socket.io-client';

import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoggerService } from './logger.service';
import { CookieService } from 'ngx-cookie-service';

const { apiUrl, socketUrl } = environment;

@Injectable({
  providedIn: 'root'
})
export class SocketService implements OnInit {
  private socket: any;

  constructor(
    private logger: LoggerService,
    private cookieService: CookieService
  ) {
    this.logger.debug(`constructor: socketUrl`, socketUrl);
    this.socket = io(`${socketUrl}/`, {
      transports: ['websocket'], // ['websocket'],
      auth: {
        wally: 'rules'
      }
    });

    this.socket.on('connect', () => {
      this.logger.debug('Connected to Socket.IO server:', this.socket?.id, this.socket?.connected);
      this.socket?.emit('clientConnected', 'Hello from Angular client!');
    });

    this.socket.on('disconnect', () => {
      this.logger.debug('Disconnected from Socket.IO server.');
    });

    this.socket.on('connect_error', (error: any) => {
      this.logger.error('Socket.IO connection error:', error);
    });

  }

  ngOnInit(): void {
  }
  // Method to send a message to the server.

  public sendMessage(message: string) {
    this.logger.debug(`sendMessage: `, message);
    this.socket?.emit('message', message); // Emits a 'message' event to the server with the provided message.
  }

  // Method to listen for incoming messages from the server.
  public onMessage() {
    return new Observable(observer => {
      this.socket?.on('message', (message: string) => { // Listens for the 'message' event from the server.
        this.logger.debug(`onMessage:onMessage:message: `, message);
        observer.next(message); // Pushes the received message to the observer.
      });
    });
  }

  public onBlast() {
    return new Observable(observer => {
      this.socket?.on('blast', (message: string) => { // Listens for the 'message' event from the server.
        this.logger.debug(`onBlast:onBlast:message: `, message);
        observer.next(message); // Pushes the received message to the observer.
      });
    });
  }

  public onRefresh() {
    return new Observable(observer => {
      this.socket?.on('refresh', (args: string) => { // Listens for the 'message' event from the server.
        this.logger.debug(`onRefresh:onRefresh:args: `, args);
        observer.next(args); // Pushes the received message to the observer.
      });
    });
  }

  public onConnection() {
    return new Observable(observer => {
      this.socket?.on('connection', (socket: any) => {
        this.logger.debug(`on connection: `, socket);
        observer.next(socket)
      })
    })
  }
}
